import { useState } from "react";
import { X } from "lucide-react";
import { clubErrorMessage, createClubCustomer } from "../../api/club";
import BirthdayField, { isBirthdayComplete } from "./BirthdayField";

const inputClass =
  "h-10 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm text-gray-800 placeholder:text-gray-400 focus:border-primary focus:outline-none focus:ring-4 focus:ring-primary/10";

export default function AddCustomerDialog({ restaurantId, onClose, onCreated }) {
  const [form, setForm] = useState({ name: "", phone: "", birthday: "", marketingConsent: false });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const set = (key) => (value) => setForm((current) => ({ ...current, [key]: value }));

  const submit = async (event) => {
    event.preventDefault();
    if (!form.phone.trim()) return setError("شماره موبایل را وارد کنید.");
    if (!isBirthdayComplete(form.birthday)) return setError("روز و ماه تولد را کامل انتخاب کنید.");
    setSaving(true);
    setError("");
    try {
      const customer = await createClubCustomer(restaurantId, form);
      onCreated(customer);
    } catch (submitError) {
      setError(clubErrorMessage(submitError, "افزودن مشتری ناموفق بود."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/30 sm:items-center" dir="rtl" role="presentation" onMouseDown={onClose}>
      <form
        onSubmit={submit}
        onMouseDown={(event) => event.stopPropagation()}
        className="w-full max-w-md rounded-t-2xl bg-white p-5 sm:rounded-2xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="add-customer-title"
      >
        <div className="flex items-center justify-between">
          <h2 id="add-customer-title" className="text-base font-extrabold text-accent">افزودن مشتری</h2>
          <button type="button" onClick={onClose} className="rounded-lg p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-700" aria-label="بستن">
            <X size={18} aria-hidden="true" />
          </button>
        </div>

        <div className="mt-4 space-y-3">
          <label className="block">
            <span className="mb-1 block text-xs font-semibold text-gray-600">شماره موبایل *</span>
            <input
              autoFocus
              inputMode="tel"
              dir="ltr"
              value={form.phone}
              onChange={(event) => set("phone")(event.target.value)}
              placeholder="09121234567"
              className={`${inputClass} text-right`}
            />
          </label>
          <label className="block">
            <span className="mb-1 block text-xs font-semibold text-gray-600">نام</span>
            <input value={form.name} onChange={(event) => set("name")(event.target.value)} className={inputClass} maxLength={120} />
          </label>
          <div>
            <span className="mb-1 block text-xs font-semibold text-gray-600">تاریخ تولد</span>
            <BirthdayField value={form.birthday} onChange={set("birthday")} idPrefix="new-birthday" />
          </div>
          <label className="flex items-start gap-2 pt-1 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={form.marketingConsent}
              onChange={(event) => set("marketingConsent")(event.target.checked)}
              className="mt-1 h-4 w-4 accent-primary"
            />
            <span>مشتری با دریافت پیامک‌های تبلیغاتی موافقت کرده است.</span>
          </label>
        </div>

        {error && <p className="mt-3 rounded-lg bg-red-50 px-3 py-2 text-xs font-medium text-red-700" role="alert">{error}</p>}

        <div className="mt-5 flex gap-2">
          <button
            type="submit"
            disabled={saving}
            className="inline-flex min-h-10 flex-1 items-center justify-center rounded-lg bg-primary px-4 text-sm font-bold text-white hover:bg-[#e8731f] disabled:opacity-60"
          >
            {saving ? "در حال ذخیره…" : "افزودن"}
          </button>
          <button type="button" onClick={onClose} className="min-h-10 rounded-lg border border-gray-200 px-4 text-sm font-bold text-gray-600 hover:bg-gray-50">
            انصراف
          </button>
        </div>
      </form>
    </div>
  );
}
